import produce from 'immer';
import {
    SET_ESTIMATIONS,
    SET_STEP,
    SET_CONTAINER_ELEMENT,
    SET_RETURN_DATA,
    RESET_RETURN_DATA,
    SET_BOOZTPAY_INVOICE_ID,
    SET_RETURN_REASONS,
    SET_RETURN_RESPONSE_DATA,
    steps
} from '../constants';

const initialState = {
    booztpayInvoiceId: null,
    step: steps.first,
    containerElement: null,
    order: null,
    returnData: {},
    reasons: null,
    returnResponseData: {},
    estimations: null
};

// eslint-disable-next-line import/prefer-default-export
export const orderReturn = produce((state, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_ESTIMATIONS:
            state.estimations = payload;
            break;

        case SET_BOOZTPAY_INVOICE_ID:
            state.booztpayInvoiceId = payload;
            break;

        case SET_STEP:
            state.step = payload;
            break;

        case SET_CONTAINER_ELEMENT:
            state.containerElement = payload;
            break;

        case SET_RETURN_DATA: {
            const { returnData } = payload;
            state.returnData = returnData;
            break;
        }

        case RESET_RETURN_DATA: {
            state.estimations = null;
            state.returnData = {};
            break;
        }

        case SET_RETURN_REASONS:
            state.reasons = payload;
            break;

        case SET_RETURN_RESPONSE_DATA:
            state.returnResponseData = payload;
            break;

        // skip default
    }
}, initialState);
